import { TrainingSystem, IrrigationType, PlantingOut, Planting, VineyardDenomination, VineyardRootstock, VineyardLayering, VegetativeState, ProtectionType } from './../models/Block';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { NumTreeEstimate, PlotMbr } from '../models/Plot';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
export default class PlantingApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    async getPlantingDefault(plot_id: number, block_id: number): Promise<Planting> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/blocks/${block_id}/planting_defaults`)

        return res.data;
    }

    async getTrainingSystems(): Promise<TrainingSystem[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_training_system`, {
            params: {
                offset: 0,
                count: 300
            }
        })

        return res.data.records
    }

    async getIrrigationTypes(): Promise<IrrigationType[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_irrigation_type`, {
            params: {
                offset: 0,
                count: 300
            }
        })

        return res.data.records
    }

    async getProtectionTypes(): Promise<ProtectionType[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_protection_type`, {
            params: {
                offset: 0,
                count: 300
            }
        })

        return res.data.records
    }

    async editPlanting(plot_id: number, block_id: number, editedPlanting: PlantingOut): Promise<Planting> {
        const res = await this.http.put(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/blocks/${block_id}/planting`, editedPlanting);

        return res.data
    }

    async deletePlanting(plot_id: number, block_id: number): Promise<Planting> {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/blocks/${block_id}/planting`);

        return res.data;
    }

    async getGpToken(): Promise<string>{
        const env = {
            "env": "PORTALE_PROD",
            "context": null,
            "userid": null,
            "password": "aBACFarm3r2020!"
        };
        // {"env":"PORTALE_PROD","context":null,"userid":null,"password":"aBACFarm3r2020!"}
        const url = "https://geoproxy-prod.abacofarmer.com/login";
        const res = await this.http.post(url, env);
        return res.data;
    }

    async getNumTreeEstimate(wkt: string, gptoken: string): Promise<NumTreeEstimate>{
        const unauthHttp = new HTTPClient();
        // const url = "http://ec2-18-193-171-42.eu-central-1.compute.amazonaws.com/counting-trees/api/v1.0/countingtreesdemo/countTreesFast";
        const url = "/counting-trees/api/v1.0/countingtrees/countTrees";
        const params = {
            wkt,
            gptoken
        }
        const res = await unauthHttp.get(url, {params});
        return res.data;
    }

    async getVineyardDenominations(filter: string | null, paging: PagingParams): Promise<PagedResults<VineyardDenomination>> {
        const filters = [];
        if(filter){
            filters.push(`^ds_designation_type like ${filter.toUpperCase()}`)
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_designation_type`, {
            params: {
                filter: filters.length > 0 ? filters : undefined,
                count: paging.count,
                offset: paging.offset
            }
        });
        //res.data.records = res.data.records.map((e: VineyardDenomination) => { return {...e, ds_designation_type: this.ucFirst(e.ds_designation_type)} }); removed per #95346
        return res.data;
    }

    async getRootstocks(): Promise<VineyardRootstock[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_rootstock_type`, {
            params: {
                count: 300,
                offset: 0
            }
        });
        return res.data.records;
    }

    async getLayerings(): Promise<VineyardLayering[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_lying_type`, {
            params: {
                count: 300,
                offset: 0
            }
        });
        return res.data.records;
    }

    async getVegetativeStates(): Promise<VegetativeState[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_veg_status_type`, {
            params: {
                count: 300,
                offset: 0
            }
        });
        return res.data.records;
    }

    //lowercase string and uppercase first letter
    private ucFirst(str: string | null): string{
        if(str && str.length > 0){
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        } else {
            return "";
        }
    }

}
